/** The "allow a manual entry" contract shared by Dropdown, People and Company. */
export interface CustomValueConfig {
  allowCustomValue: boolean;
  customMinLength?: number;
  customMaxLength?: number;
}

export function parseCustomValueConfig(configJson: string): CustomValueConfig {
  try {
    const parsed: unknown = JSON.parse(configJson || '{}');
    const record = parsed as Record<string, unknown>;
    return {
      allowCustomValue: record.allowCustomValue === true,
      customMinLength: typeof record.customMinLength === 'number' ? record.customMinLength : undefined,
      customMaxLength: typeof record.customMaxLength === 'number' ? record.customMaxLength : undefined
    };
  } catch {
    return { allowCustomValue: false };
  }
}

/** Only applies to a manually-typed value; empty is left to the required check. */
export function customValueLengthError(value: string, config: CustomValueConfig): 'tooShort' | 'tooLong' | null {
  if (!value) return null;
  if (config.customMinLength !== undefined && value.length < config.customMinLength) return 'tooShort';
  if (config.customMaxLength !== undefined && value.length > config.customMaxLength) return 'tooLong';
  return null;
}

/** Parsed shape of a Dropdown property's configJson: the shared contract plus its option list. */
export interface DropdownConfig extends CustomValueConfig {
  options: string[];
}

export function parseDropdownConfig(configJson: string): DropdownConfig {
  const base = parseCustomValueConfig(configJson);
  try {
    const parsed: unknown = JSON.parse(configJson || '{}');
    const record = parsed as Record<string, unknown>;
    return { ...base, options: Array.isArray(record.options) ? record.options.map(String) : [] };
  } catch {
    return { ...base, options: [] };
  }
}
